/**
 * Shared Axios client for webwalker-core admin REST (`VUE_APP_ROOT_API`).
 * Attaches Bearer token from Vuex when present; clears it when absent.
 * No response interceptors — callers handle 401/503/errors themselves.
 */
import axios from "axios";
import store from "@/store";

let CoreApi = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

let Api = function() {
  if (store.state.token) {
    CoreApi.defaults.headers.common["Authorization"] = 'Bearer ' + store.state.token;
  } else {
    delete CoreApi.defaults.headers.common["Authorization"];
  }

  return CoreApi;
};

export default Api;
